import {transactionType} from '../../../Page/TransactionSummaryPage/Shared/Constants';

export function setLabels(dealType, reasonCode) {
  const labels = {};

  switch (dealType) {
    case transactionType.Accessory:
    case transactionType.Replace:
    case transactionType.Change:
    case transactionType.Provide:
      labels.saleDate = 'תאריך העסקה';
      labels.orderNumber = 'מספר הזמנה';
      break;
    case transactionType.Disconnect:
      if (reasonCode === 'DL') {
        labels.saleDate = 'תאריך בקשת ביטול עסקה';
        labels.orderNumber = 'מספר הזמנת ביטול עסקה';
      } else {
        labels.saleDate = 'תאריך בקשת ניתוק';
        labels.orderNumber = 'מספר הזמנת ניתוק';
      }
      break;
    default:
      labels.saleDate = 'תאריך ביטול עסקה';
      labels.orderNumber = 'מספר הזמנת עסקת ביטול';
      labels.createOrder = 'תאריך בו בוצעה העסקה המקורית';
  }

  return labels;
}
export function setTittle(dealType, context) {
  let tittle;
  switch (dealType) {
    case transactionType.CancelDeal:
      tittle = context.generalCancelDealTopic.value;
      break;
    default:
      tittle = context.generalDetailsTopic.value;
      break;
  }

  return tittle;
}
